import * as React from 'react'

import { HorizontalAlignment } from '@thg-commerce/enterprise-core'
import { GlobalTwoItemImageTextCta } from '@thg-commerce/enterprise-network/src/generated/graphql'
import { useTheme } from '@thg-commerce/enterprise-theme'
import {
  ImageOverlayCollection,
  ImageOverlayCollectionProps,
} from '@thg-commerce/enterprise-widget-image-collection-overlay'

import { BaseWidgetProps } from '../types'

export type ImageOverlayCollectionRendererProps = BaseWidgetProps &
  Omit<GlobalTwoItemImageTextCta, 'query'>

export const ImageOverlayCollectionRenderer = (
  props: ImageOverlayCollectionRendererProps,
) => {
  const theme = useTheme()
  const imageOverlayCollectionProps: ImageOverlayCollectionProps = {
    textColor: props.contentTheme === 'light' ? 'light' : 'dark',
    items: [
      {
        image: {
          urls: {
            small: props.itemOneImageSmall || undefined,
            medium: props.itemOneImage,
            large: props.itemOneImage,
          },
          link: props.itemOneURL || undefined,
          alt: props.itemOneImageAltText || undefined,
        },
        title: props.itemOneTitle || undefined,
        subtitle: props.itemOneDescription || undefined,
        itemAlignment: {
          vertical: theme.widget.imageCollectionOverlay.itemAlignment.vertical,
          horizontal:
            (props.itemOneContentAlign as HorizontalAlignment) || 'center',
        },
        cta: {
          text: props.itemOneCTAText || '',
          link: props.itemOneURL || '',
        },
      },
      {
        image: {
          urls: {
            small: props.itemTwoImageSmall || undefined,
            medium: props.itemTwoImage,
            large: props.itemTwoImage,
          },
          link: props.itemTwoURL || undefined,
          alt: props.itemTwoImageAltText || undefined,
        },
        title: props.itemTwoTitle || undefined,
        subtitle: props.itemTwoDescription || undefined,
        itemAlignment: {
          vertical: theme.widget.imageCollectionOverlay.itemAlignment.vertical,
          horizontal:
            (props.itemTwoContentAlign as HorizontalAlignment) || 'center',
        },
        cta: {
          text: props.itemTwoCTAText || '',
          link: props.itemTwoURL || '',
        },
      },
    ],
  }
  return <ImageOverlayCollection {...imageOverlayCollectionProps} />
}
